<template>
  <div>
    <b-modal id="addStudentOpportunityModal"
             ref="newStudentOpportunityModal"
             title="Add New Student Opportunity"
             ok-title="Save"
             @ok="handleOk">
      <add-student-opportunity ref="newStudentOpportunityComponent"
                               :translationalTeamId="translationalTeam.translationalTeamId"
                               v-if="translationalTeam.translationalTeamId"
                               @saved="closeModal"></add-student-opportunity>
    </b-modal>

    <div v-if="studentOpportunities.length" class="students-div">
      <div class="top-controls">
        <strong class="table-header">Students</strong>
        <b-input-group class="filter-group">
          <b-input-group-prepend is-text>
            <font-awesome-icon icon="search" />
          </b-input-group-prepend>
          <b-form-input v-model="studentsFilter" placeholder="Type to Search"></b-form-input>
          <b-input-group-append>
            <b-button @click="studentsFilter = null">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>

      <b-table striped 
              :items="studentOpportunities"
              :fields="studentsFields"
              :per-page="studentsPerPage"
              :current-page="studentsCurrentPage"
              :filter="studentsFilter"
              @filtered="onStudentsFiltered"
              sortBy="asuriteId"
              small>
        <template slot="student" slot-scope="data">
          {{data.item.student.firstName}} {{data.item.student.lastName}}
        </template>
        <template slot="opportunity" slot-scope="data">
          <router-link :to="{ name: 'opportunity', params: { opportunityId: data.item.opportunityId} }">
            {{getOpportunityByStudentOpportunityId(data.item.studentOpportunityId).term.description}} - {{getOpportunityByStudentOpportunityId(data.item.studentOpportunityId).opportunityCategory.name}}
          </router-link>
        </template>
        <template slot="view" slot-scope="data">
          <router-link :to="{ name: 'studentOpportunityDetails', params: { studentOpportunityId: data.item.studentOpportunityId } }">View</router-link>
        </template>
      </b-table>
    </div>

    <div class="align-right">
      <b-button class="btn-primary student-button"
                v-b-modal.addStudentOpportunityModal
                v-if="translationalTeam.translationalTeamId && translationalTeam.opportunities.length">
        Add Student
      </b-button>
    </div>
  </div>
</template>

<script>
import AddStudentOpportunity from "@/components/students/add-student-opportunity";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      studentsFields: [
        { key: "asuriteId" },
        { key: "student", label: "Name" },
        { key: "opportunity" },
        { key: "view", label: "" }
      ],
      studentsCurrentPage: 1,
      studentsPerPage: 10,
      studentsFilter: null,
      studentsTotalRows: 0
    };
  },

  props: {
    translationalTeam: {
      type: Object,
      required: true
    }
  },

  components: {
    "add-student-opportunity": AddStudentOpportunity
  },

  computed: {
    studentOpportunities: function() {
      var studentOpportunityArray = [];
      _.forEach(this.translationalTeam.opportunities, function(opportunity) {
        studentOpportunityArray = _.concat(
          studentOpportunityArray,
          opportunity.studentOpportunities
        );
      });
      return studentOpportunityArray;
    }
  },

  methods: {
    handleOk: function(event) {
      event.preventDefault();
      this.$refs.newStudentOpportunityComponent.save();
    },

    closeModal: function() {
      this.$refs.newStudentOpportunityModal.hide();
    },

    onStudentsFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.studentsTotalRows = filteredItems.length;
      this.studentsCurrentPage = 1;
    },

    getOpportunityByStudentOpportunityId(studentOpportunityId) {
      return _.find(this.translationalTeam.opportunities, function(
        opportunity
      ) {
        var hasStudentOpportunity = _.find(
          opportunity.studentOpportunities,
          function(studentOpportunity) {
            return (
              studentOpportunity.studentOpportunityId === studentOpportunityId
            );
          }
        );

        if (hasStudentOpportunity) {
          return true;
        }
        return false;
      });
    }
  }
};
</script>

<style scoped>
.align-right {
  text-align: right;
}

.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}

.top-controls {
  margin-bottom: 10px;
}

.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
  display: inline-flex;
}

.table-header {
  margin-right: 1em;
}
</style>
